import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';
import { BaseRestService } from "./base-rest.service";
import { TranslateService } from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseRestService {

  readonly USER_API_URL: string = environment.apiUri + '/users';
  private translate: TranslateService;

  readonly OTP_ENDPOINT: string =  environment.apiUri + '/auth/generate-temporary-password'

  getById(id: string): Observable<any> {
    return this.httpClient.get(this.USER_API_URL + "/" + id,
      { headers: this.headers });
  }

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.USER_API_URL, options);
  }

  getListByRoles(pageParams: any, request): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.post(this.USER_API_URL + '/get-by-roles', request, options);
  }

  create(user: User): Observable<any> {
    return this.httpClient.post(this.USER_API_URL, JSON.stringify(user),
      { headers: this.headers });
  }

  update(id: string, user: User): Observable<any> {
    return this.httpClient.put(this.USER_API_URL + "/" + id, JSON.stringify(user),
      { headers: this.headers });
  }

  unlock(id: string): Observable<any> {
    return this.httpClient.post(this.USER_API_URL + "/" + id + "/unlock", {},
      { headers: this.headers });
  }

  generateOTP(email: string): Observable<any> {
    return this.httpClient.put(this.OTP_ENDPOINT + "/" + email,
        { headers: this.headers });
  }

  existUsername(value: string): Observable<any> {
    return this.httpClient.get(this.USER_API_URL + "/username/" + value,
    { headers: this.headers });
  }

  existEmail(value: string): Observable<any> {
    return this.httpClient.get(this.USER_API_URL + "/email/" + value,
    { headers: this.headers });
  }

  updatePassword(id: string, data: any): Observable<any> {
    return this.httpClient.put(this.USER_API_URL + "/change-password/" + id,JSON.stringify(data),
        { headers: this.headers });
  }

  getUserPermissions(username: any) {
    return this.httpClient.get(this.USER_API_URL + `/username/usergroup/${username}`,
        { headers: this.headers });
  }

  upload(file,id): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Content-Type", " multipart/form-data");
    return this.httpClient.post(this.USER_API_URL + "/upload/" + id, file,
        { headers: headers });
  }

  download(id: string): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/octet-stream");
    return this.httpClient.get(this.USER_API_URL + "/download?userId="+id,
        { headers: headers, responseType: 'blob' }).pipe(
        catchError(this.handleError)
    );
  }

  remove(id: string): Observable<any> {
    return this.httpClient.delete(this.USER_API_URL+ "/remove?userId=" + id,
        { headers: this.headers });
  }

  handleError(error) {
    return throwError(this.translate.instant('error.something_incorrect'));
  }
}
